import type { TextNodeType } from "../../../FormattedText/FormattedText";
import FormattedText from "../../../FormattedText/FormattedText";
import type { MyCashState } from "../../ListingPageV2.types";
import { Cta, Icon, Row, TextCol, Wrap } from "./Styles";

interface MyCashDataState {
  icon?: string;
  ctaText?: string;
  title?: TextNodeType;
}

interface MyCashPersuasionProps {
  myCashData?: {
    unApplied?: MyCashDataState;
    loggedOut?: MyCashDataState;
    applied?: MyCashDataState;
  };
  myCashState?: MyCashState;
  onMyCashPress?: () => void;
}

export const MyCashPersuasion = ({
  myCashData,
  myCashState = "unApplied",
  onMyCashPress,
}: MyCashPersuasionProps) => {
  const current = myCashData?.[myCashState];
  if (!current?.title) return null;

  return (
    <Wrap>
      <Row>
        {current.icon && <Icon src={current.icon} alt="myCash" />}
        {current.title && (
          <TextCol>
            <FormattedText value={current.title} />
          </TextCol>
        )}
        {current.ctaText && (
          <Cta type="button" onClick={onMyCashPress}>
            {current.ctaText}
          </Cta>
        )}
      </Row>
    </Wrap>
  );
};
